import color from "../../../../../constants/color";

const style = {
  card:{
    mt:2,
    backgroundColor:"#fff",
    padding:"10%",
    borderRadius:"20px",
    display:"flex",
    alignItems:"center  ",
    justifyContent:"space-Between"
    // gridColumn:{ xs: "span 12", md: "span 3" }
  },
  dateCard:{
    mt:2,
    backgroundColor:"#fff",
    padding:"4%",
    borderRadius:"20px",
    display:{xs: "block", md:"flex"},    
    alignItems:"center  ",
    justifyContent:"space-Between"
    // gridColumn:{ xs: "span 12", md: "span 3" }
  },

  inputSection: {
    display: {sx:"block", md: "flex"},
    justifyContent: "space-between",
    px: 2
  },

  inputBox: {
    width: {xs:"100%", md: "49%", lg:"31%"}
  },
  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text, 
    mt:1
  },

  dateInput:{
    width: "100%",
    my:1,


    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }},
  tableHead: {
    color: "#878787",
    fontWeight: "400",
  },
    
  leaveHeading: { 
    fontWeight: 600,
    fontSize: "20px", 
  },
    
  tabledata: {
    borderBottom: 0,
  },
  percentagetext:{
    color:color.primary,
    paddingX:"3%",borderRadius:30,height:"30px",display:"flex",alignItems:"center",fontWeight:"400",fontSize:"12px"  
  },
  textHeading:{
    fontSize:"12px",
    fontWeight:"500",
    color:color.lightText
  },
  textBody: {
    fontSize:"20px",
    fontWeight:"500",
 
  },
  percentagetexts:{
    color:color.red,
    paddingX:"3%",borderRadius:30,height:"30px",display:"flex",alignItems:"center",fontWeight:"400",fontSize:"12px"  
  },
  percentageContainer:{
    backgroundColor:color.lightGreen,
    borderRadius:"30px",
    px:1,
    display:"flex",
    alignItems:"center"
  },
  percentageContainers:{
    backgroundColor:color.lightRed,
    borderRadius:"30px",
    px:1,
    display:"flex",
    alignItems:"center"

  },
  checkinBtn: {

    "& svg": {
      mr:1,
    },
    borderRadius: 50, 
    backgroundColor: "#28AA4A",
    color: "#fff", 
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow:"none",

  },
  checkinBtns: {

    "& svg": {
      mr:1,
    },
    borderBottomRightRadius : 50, 
    borderTopRightRadius : 50, 

    backgroundColor: "#28AA4A",
    color: "#fff", 
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow:"none",

  },
  csvBtns: {
    borderBottomLeftRadius : 50, 
    borderTopLeftRadius : 50, 
    px:1,
    backgroundColor: color.card,
    color: color.text, 
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow:"none",

  },


}
export default style;